import CryptoJS from 'crypto-js';

export const encryptString = (value) => {
    const cipherText = CryptoJS.AES.encrypt(value, process.env.REACT_APP_SECRET_KEY_CRYPTO).toString();
    return cipherText;
}

export const decryptString = (cipherText) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, process.env.REACT_APP_SECRET_KEY_CRYPTO);
    const originalText = bytes.toString(CryptoJS.enc.Utf8)
    return originalText;
}

export const encryptJSON = (dataJSON) => {
    const cipherText = CryptoJS.AES.encrypt(JSON.stringify(dataJSON), process.env.REACT_APP_SECRET_KEY_CRYPTO).toString();
    return cipherText;
}

export const decryptJSON = (cipherText) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, process.env.REACT_APP_SECRET_KEY_CRYPTO);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
}